export const MarginRangeIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 6.66992L15.7071 11.9628C15.3166 12.3533 14.6834 12.3533 14.2929 11.9628L12.7071 10.377C12.3166 9.98651 11.6834 9.9865 11.2929 10.377L7 14.6699"
        stroke="#525866"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 3.66992V18.4699C3 19.59 3 20.1501 3.21799 20.5779C3.40973 20.9542 3.71569 21.2602 4.09202 21.4519C4.51984 21.6699 5.07989 21.6699 6.2 21.6699H21"
        stroke="#525866"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
